import { Injectable, NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, formatDate } from '@angular/common';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { customDatePipe } from 'src/app/shared/pipe/custom-date-pipe';
import * as constant from '../../shared/constants/constants';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { StorageService } from 'src/app/shared/services/storage.service';
import { EstimatedImpactComponent } from 'src/app/estimated-impact/estimated-impact.component';
import { HeaderDetailsCardComponent } from 'src/app/header-details-card/header-details-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { ScenarioSKULevelTableComponent } from 'src/app/scenario-sku-level-table/scenario-sku-level-table.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { MaterialModule } from '../material.module';
import { ResultComponent } from "../../result/result.component";
import { TwoDigitDecimalNumberDirective } from 'src/app/shared/directives/two-digit-decimal-number.directive';
import { ThousandSeparator } from 'src/app/shared/pipe/thousand-separator.pipe';
import { PriceHierarchyPopupComponent } from 'src/app/price-hierarchy-popup/price-hierarchy-popup.component';
import { ShowIfTruncatedDirective } from 'src/app/shared/directives/showIfTruncated.directive';
import { GoogleMapsModule } from '@angular/google-maps';

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
};

@Injectable() class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: string): string {
    return formatDate(date, displayFormat, constant.common.locale);
  }
}

@NgModule({
  declarations: [
    TwoDigitDecimalNumberDirective,
    customDatePipe,
    EstimatedImpactComponent,
    HeaderDetailsCardComponent,
    ResultComponent,
    ScenarioSKULevelTableComponent,
    
    ThousandSeparator,
    PriceHierarchyPopupComponent,
    ShowIfTruncatedDirective,
  ],
  imports: [
    CommonModule,
    TableVirtualScrollModule,
    ScrollingModule,
    DropdownModule,
    FormsModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    MultiSelectModule,
    ButtonModule,
    MaterialModule,
    GoogleMapsModule,
    DatePipe
  ],
  exports: [
    MaterialModule,
    MultiSelectModule,
    TwoDigitDecimalNumberDirective,
    TableVirtualScrollModule,
    ScrollingModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    EstimatedImpactComponent,
    HeaderDetailsCardComponent,
    ResultComponent,
    customDatePipe,
    ScenarioSKULevelTableComponent,
    ThousandSeparator,
    PriceHierarchyPopupComponent,
    ShowIfTruncatedDirective,
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    DatePipe, ThousandSeparator
  ]
})
export class SharedModule {
  constructor(private storageService: StorageService) {
    this.callSas(constant.storage_keys.configuration);
  }

  async callSas(key: any) {
    const data = await this.storageService.get(key);
    CUSTOM_DATE_FORMAT.display.dateInput = data[constant.configuration_keys.date_format];
  }
}